// app/javascript/controllers/url_params_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["backLink"]

    connect() {
        const urlParams = new URLSearchParams(window.location.search).toString()
        const backUrl = this.backLinkTarget.href
        this.backLinkTarget.href = backUrl + (urlParams ? "?" + urlParams : "")
    }
}
